/**
 * Calculate what percentage of the overall interactions a subset of interactions makes up.
 * @param overallCount The number of overall interactions.
 * @param count        The number of interaction in a subset of the overall interactions.
 * @returns A percentage value.
 */
export const calculatePercentageValue = (overallCount: number | undefined, count: number | undefined) => {
    if (typeof overallCount === "undefined" || typeof count === "undefined") {
        return undefined;
    }

    if (overallCount === 0 || count === 0) {
        return 0;
    }

    return 100 * (count / overallCount);
};
